import { useCompanyOSIntegrationEnabled } from "@mirage/mosaics/BaseProfilePage/utils";
import { useUserProfileApi } from "@mirage/mosaics/UserProfilePage/hooks";
import { UserProfilePageLayout } from "@mirage/mosaics/UserProfilePage/UserProfilePageLayout";
import { useDashTitle } from "@mirage/shared/hooks/DashTitle";
import { useLocation, useNavigate } from "react-router-dom";

export const UserProfilePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = location.pathname.split("/")[2];
  const isEdit = location.pathname.endsWith("/edit");

  const userInfo = useUserProfileApi({ userId });

  useDashTitle(userInfo?.name ?? "");

  if (!useCompanyOSIntegrationEnabled() || !userId) {
    navigate("/");
    return null;
  }

  return userInfo && <UserProfilePageLayout user={userInfo} isEdit={isEdit} />;
};
